<template>
    <p> <b>{{title}}</b></p>
    <template v-for="(a, k) in data?.slice(0, show? data.length: len)" :key="k">
        <a-tag color="blue" style="margin-right: 5px">{{a}}</a-tag>
    </template>

    <span v-if="data.length > len" @click="handle">
        <a v-if="show"> 收起 </a>
        <span v-else>
            ...<a-tag color="blue" style="margin-right: 5px">{{data[data.length - 1]}}</a-tag>
            <a>显示全部</a>
        </span>
    </span>
    <template v-if="show">
        <slot name="extra"></slot>
    </template>

</template>

<script>
    export default {
        name: "ShowAll",
        props: ['title', 'text', 'initLen', 'extra'],
        data(){
            return {
                show: false,
                data: [],
                len: this.initLen || 1
            }
        },
        created(){
            this.text2Arr(this.text);
        },
        watch: {
            text: function(newValue, oldValue){
                if(newValue !== oldValue) this.text2Arr(newValue);
            }
        },
        methods: {
            text2Arr(text){
                if(typeof text === 'string') this.data = text.split(',')
            },
            handle(){
                this.show = !this.show;
            }
        }
    }
</script>

<style scoped>

</style>
